import { AutoStack, FormikGraphQLDatePicker } from 'components'
import { DayPickerStrings, onFormatDate } from 'components/DatePickers/helpers'
import { FieldProps } from 'formik'
import { AuthorizedField as Field } from 'forms/AuthorizedField'
import { FieldStack, FieldStackItem, FormStack } from 'forms/FormStack'
import * as model from 'model'
import { Proving } from 'model'
import { DayOfWeek, DefaultButton, Label, Stack } from 'office-ui-fabric-react'
import * as React from 'react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ParticipantListItem } from 'views/ParticipantViews'
import { ResourceOfficeBookingListItem } from 'views/ResourceBookingsView'
import * as Yup from 'yup'

export type ParticipantHeadOfProvingFormValues = Proving
export class ParticipantHeadOfProvingFormSchema {
  constructor(provingDateFrom: string, provingDateTo: string) {
    return Yup.object().shape({
      dateFrom: Yup.date().required(),
      dateTo: Yup.date()
        .required()
        .when(
          'dateFrom',
          (dateFrom: any, schema: any) => dateFrom && schema.min(dateFrom)
        ),
    })
  }
}

export const ParticipantHeadOfProvingForm: React.FC<{
  proving: Partial<model.Proving>
  notification?: boolean
  participant?: Partial<ParticipantListItem>
  resource?: Partial<ResourceOfficeBookingListItem>
  selection?: Partial<ParticipantListItem>
}> = ({ proving, notification, participant, resource, selection }) => {
  const { t } = useTranslation()
  const [resultArray, setResultArray] = useState<any[]>([])
  const [selectionDateFrom, setSelectionDateFrom] = useState(
    selection && selection.headOfProving && selection.headOfProving.dateFrom
  )
  const [selectionDateTo, setSelectionDateTo] = useState(
    selection && selection.headOfProving && selection.headOfProving.dateTo
  )

  // const validateDateFrom = () => {
  //   if (selection) {
  //     return new Date(selection.dateFrom as any)
  //   } else if (resource) {
  //     return new Date(resource.provingDateFrom as any)
  //   } else if (proving) {
  //     return new Date(proving.dateFrom)
  //   } else {
  //     return false
  //   }
  // }

  // const validateDateTo = () => {
  //   if (selection) {
  //     return new Date(selection.dateTo as any)
  //   } else if (resource) {
  //     return new Date(resource.provingDateTo as any)
  //   } else if (proving) {
  //     return new Date(proving.dateTo)
  //   } else {
  //     return false
  //   }
  // }

  const validateHoP = (dateFrom?: any, dateTo?: any) => {
    const latestDate: Date = new Date(proving.dateTo)
    const lowestDate: Date = new Date(proving.dateFrom)
    const diffTime = Math.abs(latestDate.getTime() - lowestDate.getTime())
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24) + 1)
    const headOfProvings = new Array<number>(diffDays).fill(0)
    const dates: string[] = []
    const dateColumn = [] as any
    let dateFromSelected: any = ''
    let dateToSelected: any = ''
    let index = 0
    if (dateTo) {
      setSelectionDateTo(dateTo)
      dateToSelected = dateTo
    }

    if (dateFrom) {
      setSelectionDateFrom(dateFrom)
      dateFromSelected = dateFrom
    }

    for (
      lowestDate;
      lowestDate <= latestDate;
      lowestDate.setDate(lowestDate.getDate() + 1)
    ) {
      const dateOptions = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      }
      dates.push(lowestDate.toLocaleDateString('de-DE', dateOptions))
      if (proving && proving.participants) {
        for (let p = 0; p < proving.participants.length; p++) {
          if (proving.participants[p] !== selection) {
            if (
              new Date(proving!.participants![p].headOfProving!.dateFrom) <=
                lowestDate &&
              new Date(proving!.participants![p].headOfProving!.dateTo) >=
                lowestDate
            ) {
              headOfProvings[index] += 1
            }
          } else {
            if (dateFromSelected) {
              if (
                new Date(dateFromSelected) <= lowestDate &&
                new Date(selectionDateTo) >= lowestDate
              ) {
                headOfProvings[index] += 1
              }
            } else if (dateToSelected) {
              if (
                new Date(selectionDateFrom) <= lowestDate &&
                new Date(dateToSelected) >= lowestDate
              ) {
                headOfProvings[index] += 1
              }
            }
          }
        }
      }
      index++
    }

    headOfProvings.forEach((hop, i) => {
      if (hop === 0) {
        dateColumn.push({ hop: dates[i] })
      }
    })
    setResultArray(dateColumn)
  }

  return (
    <AutoStack tokens={{ childrenGap: 12 }}>
      <FormStack>
        {notification && (
          <FieldStack>
            <Label>
              {t(
                'Achtung! Es sind mehrere Einträge ausgewählt! Die Werte werden bei allen ausgewählten Einträgen mit den Werten aus der Formularmaske überschrieben!'
              )}
            </Label>
          </FieldStack>
        )}
        <Label required={true}>{t('field.timespan.label')}</Label>
        <FieldStack horizontal={true}>
          <FieldStackItem
            name="headOfProving.dateFrom"
            label={t('field.dateFrom.label')}
            isRequired={true}
            component={FormikGraphQLDatePicker}
            // minDate={validateDateFrom()}
            // maxDate={validateDateTo()}
            firstDayOfWeek={DayOfWeek.Monday}
            strings={DayPickerStrings}
            showWeekNumbers={true}
            formatDate={onFormatDate}
            onSelectDate={(dateFrom: any) => {
              setSelectionDateFrom(dateFrom)
              validateHoP(dateFrom)
            }}
            initialPickerDate={new Date(proving.dateFrom)}
          />
          <FieldStackItem
            name="headOfProving.dateTo"
            label={t('field.dateTo.label')}
            isRequired={true}
            component={FormikGraphQLDatePicker}
            // minDate={validateDateFrom()}
            // maxDate={validateDateTo()}
            firstDayOfWeek={DayOfWeek.Monday}
            strings={DayPickerStrings}
            showWeekNumbers={true}
            formatDate={onFormatDate}
            onSelectDate={(dateTo: any) => {
              setSelectionDateTo(dateTo)
              validateHoP(undefined, dateTo)
            }}
            initialPickerDate={new Date(proving.dateFrom)}
          />
        </FieldStack>
      </FormStack>
      <Field
        render={(fieldProps: FieldProps<any>) => (
          <DefaultButton
            text={t('field.resetDateParticipant.label')}
            onClick={() => {
              fieldProps.form.setFieldValue(
                'headOfProving.dateFrom',
                (selection && selection.dateFrom) ||
                  (proving && proving.dateFrom) ||
                  (resource && resource.provingDateFrom)
              )
              fieldProps.form.setFieldValue(
                'headOfProving.dateTo',
                (selection && selection.dateTo) ||
                  (proving && proving.dateTo) ||
                  (resource && resource.provingDateTo)
              )
            }}
          />
        )}
      />
      {resultArray && resultArray.length > 0 && (
        <FieldStack>
          <Stack.Item>
            <Label>
              An folgenden Tagen ist kein Erprobungsleiter definiert:
            </Label>
            {resultArray.map((x: any, i: number) => {
              return (
                <FieldStack key={i}>
                  <table>
                    <tbody>
                      <tr>
                        <td>{x.hop}</td>
                      </tr>
                    </tbody>
                  </table>
                </FieldStack>
              )
            })}
            <Label>{t('Möchten Sie trotzdem fortfahren?')}</Label>
          </Stack.Item>
        </FieldStack>
      )}
    </AutoStack>
  )
}
